import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ModalController } from '@ionic/angular';
import { MaskitoOptions } from '@maskito/core';
import { select, Store } from '@ngrx/store';

import { SeriesOption } from 'echarts';
import { cloneDeep, filter, map } from 'lodash-es';
import { Observable, tap } from 'rxjs';

import { calculatorChartOptions } from '../../../../constants/calculator-chart-options.constants';
import { rateMask } from '../../../../constants/maskito.constants';
import * as fromCalculatorActions from '../../../../store/actions/calculator.actions';
import * as fromCalculatorSelectors from '../../../../store/selectors/calculator.selectors';
import { PitiData } from '../../../../typings/calculator';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-piti-report-modal',
  standalone: false,
  templateUrl: './report-modal.component.html'
})
export class ReportModalComponent {
  private modalController = inject(ModalController);
  private store = inject(Store);

  selectData$: Observable<PitiData>;
  reportData: PitiData | undefined;

  chartOptions = cloneDeep(calculatorChartOptions);

  readonly rateMask: MaskitoOptions = rateMask;

  constructor() {
    this.selectData$ = this.store.pipe(
      select(fromCalculatorSelectors.selectPitiData),
      tap((data) => {
        this.handleChartData(data);
        this.reportData = data;
      })
    );
  }

  close() {
    return this.modalController.dismiss(null, 'cancel');
  }

  async save() {
    if (this.reportData) {
      this.store.dispatch(
        fromCalculatorActions.savePITIReport({
          payload: { reportData: this.reportData }
        })
      );
    }

    await this.close();
  }

  private handleChartData(data: PitiData) {
    (this.chartOptions.series as SeriesOption[])[0].data = filter(
      map(
        [
          {
            label: 'P&I',
            value: data.principalAndInterest
          },
          {
            label: 'PMI',
            value: data.privateMortgageInsurance
          },
          {
            label: 'Taxes',
            value: data.propertyTax
          },
          {
            label: 'Insurance',
            value: data.monthlyHomeownersInsurance
          }
        ],
        (item) => {
          return {
            name: item.label,
            value: item.value
          };
        }
      ),
      (item) => item.value > 0
    );
  }
}
